<template>
  <div class="subjectAction">
    <div class="top wbg" v-if='$common.AUTH("accsuer:index")'>
      <div class="group">
        <a-form-model ref="ruleForm" :model="form">
          <div class="label">
            姓名/名称：
            <a-input v-model="form.title" placeholder='请输入姓名/名称' style="width: 167px;"> </a-input>
          </div>
          <div class="allbtns">
            <a-button icon="search" @click="query(1)">查询</a-button>
            <a-button style="min-width: 64px;" @click="resetList">重置</a-button>
            <a-button v-if="$common.AUTH('accuser:add')" icon="plus" @click="addAlert()">新增</a-button>
          </div>
        </a-form-model>
      </div>
    </div>
    <div class="tcon wbg">
      <div class="tableList" v-if='$common.AUTH("accsuer:index")'>
        <a-table rowKey="id" :columns="columns" :data-source="data" :pagination="page" @change="query">
          <template slot="citys" slot-scope="text, record">
            <span v-if="record.province">
              {{ record.province }}{{ record.city }}{{ record.area }}{{ record.addr }}
            </span>
            <span v-else>/</span>
          </template>
          <template slot="dwell_province" slot-scope="text, record">
            <span v-if="record.dwell_province">
              {{ record.dwell_province }}{{ record.dwell_city }}{{ record.dwell_area }}{{ record.dwell_addr }}
            </span>
            <span v-else>/</span>
          </template>
          <div slot="alist" slot-scope="text, record">
            <a v-if="$common.AUTH('accuser:edit')" @click="addAlert(record.id)">修改</a>
            <a href='javascript:void(0);' style="margin-left:10px;" @click="debtorsAlert(record)"
              v-if='record.debtors.length > 0'>挂靠人员列表</a>
          </div>
        </a-table>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
    <a-modal v-model="modalVisible" :title="editId ? '修改原告' : '新增原告'" width="692px" :footer="null" @cancel='reset()'>
      <div class="change-subject" style="padding-bottom: 20px;z-index:999">
        <a-form-model ref="addForm" :model="subjectForm" :rules="rules" :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }">
          <a-form-model-item label="原告类型" prop="type">
            <a-select placeholder="请选择原告类型" v-model="subjectForm.type" show-search :filter-option="filterOption">
              <a-select-option :value="2">企业</a-select-option>
              <a-select-option :value="1">个人</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="subjectForm.type == 2 ? '名称' : '姓名'" prop="realname">
            <a-input v-model="subjectForm.realname" placeholder='请输入名称' v-if="subjectForm.type == 2"></a-input>
            <a-input v-model="subjectForm.realname" placeholder='请输入姓名' v-if="subjectForm.type == 1"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="subjectForm.type == 2 ? '统一社会信用代码' : '证件号码'" prop="chinaid">
            <a-input v-model="subjectForm.chinaid" placeholder='请输入统一社会信用代码' :maxLength="18"
              v-if="subjectForm.type == 2"></a-input>
            <a-input v-model="subjectForm.chinaid" placeholder='请输入证件号码' :maxLength="18" v-if="subjectForm.type == 1"
              @blur="getSex(subjectForm.chinaid)"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="subjectForm.type == 1 ? '户籍地' : '注册地'">
            <a-cascader :options="options" placeholder="请选择"
              :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='subjectForm.citys'
              @change="citysCg" />
            <a-input v-model="subjectForm.addr" type='textarea' style="margin-top:20px;" placeholder="请输入详细地址"
              @blur="AddCg" />
          </a-form-model-item>
          <a-form-model-item :label="subjectForm.type == 1 ? '常住地' : '办公地'">
            <a-cascader :options="options" placeholder="请选择"
              :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='subjectForm.dwell'
              @change="dwellCg" />
            <a-input v-model="subjectForm.dwell_addr" type='textarea' style="margin-top:20px;" placeholder="请输入详细地址" />
          </a-form-model-item>
          <a-form-model-item label="联系方式">
            <a-input v-model="subjectForm.phone" placeholder='请输入联系方式'></a-input>
          </a-form-model-item>
          <a-form-model-item label="性别" prop="sex" v-if="subjectForm.type == 1">
            <a-select placeholder="请选择性别" v-model="subjectForm.sex" show-search :filter-option="filterOption">
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="业务部门" prop="team_ids" v-if="subjectForm.type == 2">
            <a-select placeholder="请选择业务部门" v-model="subjectForm.team_ids" mode="multiple" show-search
              :filter-option="filterOption">
              <a-select-option v-for="item in tlist" :key="item.id">{{ item.title }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="挂靠企业" prop="accuser_id_new" v-if="subjectForm.type == 1">
            <a-select show-search v-model="subjectForm.accuser_id_new" placeholder="请选择挂靠企业"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
              :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
              @search="handleSearch">
              <a-select-option v-for="d in accuser" :key="d.accuser_id_new">
                <Normap :tit='d.realname'>{{ d.realname }}</Normap>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="备注" prop="comment">
            <a-input v-model='subjectForm.comment' placeholder='请输入特殊备注' type="textarea" style="height:80px;"></a-input>
          </a-form-model-item>
        </a-form-model>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='subjectConfirm'>
            <a-button type="primary" style="width:148px;margin-right:20px;">
              提交
            </a-button>
          </a-popconfirm>
          <a-button style='background:#B2C9E1;color:#fff;width:148px;' @click='reset'>取消</a-button>
        </a-form-model-item>
      </div>
    </a-modal>
    <a-modal v-model="listVisible" title="挂靠人员" width="1000px" centered :footer="null">
      <div class="table" style="padding-bottom: 20px;">
        <table>
          <thead>
            <td width='120'>录入时间</td>
            <td width='60'>姓名</td>
            <td width='120'>证件号码</td>
            <td width='140'>户籍地</td>
            <td width='140'>常住地</td>
            <td width='60'>操作</td>
          </thead>
          <tbody>
            <tr v-for='(k, n) in debtorslist' :key="n">
              <td>
                <span class="curpoter">
                  <Tooltip :tit='k.create_time'></Tooltip>
                </span>
              </td>
              <td>
                <span class="curpoter">
                  <Tooltip :tit='k.realname'></Tooltip>
                </span>
              </td>
              <td>
                <span class="curpoter">
                  <Tooltip :tit='k.chinaid'></Tooltip>
                </span>
              </td>
              <td>
                <span class="curpoter">
                  <Tooltip :tit="k.province + k.city + k.area + k.addr"></Tooltip>
                </span>
              </td>
              <td>
                <span class="curpoter">
                  <Tooltip :tit="k.dwell_province + k.dwell_city + k.dwell_area + k.dwell_addr"></Tooltip>
                </span>
              </td>
              <td><a href="javascript:void(0);" @click='takeAlert(k)'>修改</a></td>
            </tr>
          </tbody>
        </table>
        <div style="text-align:center;padding-top:20px;" v-if='debtorstotal > 10'>
          <a-pagination v-model="forms.page" :total="debtorstotal" show-less-items show-quick-jumper :pageSize='10'
            @change='turnpage' />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getSubject, accuserInfo, plaintiffEdit, plaintiffAdd, accuserdebtorlists } from '@/server/subjectAction'
import { getAccuserAll, accuseList } from '@/server/api'
import { teamList } from '@/server/directory'
import Validator from "@/assets/js/yz"
import city from "@/assets/js/city.json"
import { citySort } from '@/assets/js/unit'
const columns = [
  {
    title: '录入时间',
    key: 'create_time',
    dataIndex: 'create_time',
    width: 210
  },
  {
    title: '名称',
    key: 'realname',
    dataIndex: 'realname',
    width: 330
  },
  {
    title: '统一社会信用代码',
    key: 'chinaid',
    dataIndex: 'chinaid',
    width: 210
  },
  {
    title: '注册地',
    key: 'citys',
    dataIndex: 'citys',
    scopedSlots: { customRender: 'citys' }
  },
  {
    title: '办公地',
    key: 'dwell_province',
    dataIndex: 'dwell_province',
    scopedSlots: { customRender: 'dwell_province' }
  },
  {
    title: '联系方式',
    key: 'phone',
    dataIndex: 'phone',
    width: 140
  },
  {
    title: '操作',
    key: 'alist',
    dataIndex: 'alist',
    scopedSlots: { customRender: 'alist' },
    width: 160
  },
];
export default {
  data() {
    return {
      options: citySort(city),
      selectedRowKeys: [],
      form: {
        title: '',
      },
      editId: '',
      modalVisible: false,
      listVisible: false,
      columns,
      data: [],
      subjectForm: {
        type: 2,
        realname: '',
        chinaid: '',
        phone: '',
        sex: '',
        team_ids: [],
        // registered_address: '', //注册地,
        // office_address: '', //办公地
        phone: '',  //联系方式
        citys: null,
        dwell: [],
        accuser_id_new: '',
        province: '',
        city: '',
        area: '',
        addr: '',
        dwell_province: '',
        dwell_city: '',
        dwell_area: '',
        dwell_addr: '',
        comment: '',
        party_role: 1,
      },
      tlist: [],
      rules: {
        type: [{ required: true, message: '请选择原告类型', trigger: 'change' }],
        realname: [
          { required: true, message: '请输入姓名/名称', trigger: 'blur' },
          { message: '姓名/名称只能是汉字、字母和数字', trigger: 'blur', validator: Validator.companyName },
        ],
        chinaid: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        team_ids: [{ required: true, message: '请选择业务部门', trigger: 'change' }]
      },
      page: {
        current: 1,
        pageSize: 10,
        // showQuickJumper: true,
        // showSizeChanger: true,
        showQuickJumper: true,
        showLessItems: true,
        total: 0,
        showTotal(total) {
          return `小计 ${total} `
        }
      },
      groupData: this.$store.state.user ? this.$store.state.user.link_group : [],
      all: {
        limit: 50,
        page: 1,
        title: null,
      },
      accuser: [],
      debtorslist: [],
      debtorstotal: 0,
      forms: {
        page: 1,
        limit: 10,
        accuserIdNew: ''
      }
    }
  },
  created() {
    teamList({ limit: 100 }).then(e => {
      this.tlist = e.list
    })

    this.query()
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      // console.log(e)
      if (e.keyCode == 13) {
        _this.query()
      }
    }
  },
  methods: {
    turnpage(val) {
      this.forms.page = val;
      this.getdebtorsList()
    },
    getdebtorsList(id) {
      this.forms.accuserIdNew = id
      accuserdebtorlists(this.forms).then(res => {
        this.debtorstotal = res.total
        this.debtorslist = res.list
      })
    },
    AddCg(val) {
      if (this.subjectForm.dwell_addr.length == 0) {
        this.subjectForm.dwell_addr = this.subjectForm.addr
      }
    },
    getSex(UUserCard) {
      this.subjectForm.sex = parseInt(UUserCard.substr(16, 1)) % 2 == 2 ? 1 : 2
    },
    isEdit(Arr, val) {
      if (Arr) {
        let bool = Arr.filter(ele => {
          return val.split(",").indexOf(ele.field) >= 0
        }).length > 0 ? true : false;
        return bool
      }
    },
    citysCg(val) {
      this.subjectForm.citys = val
      this.subjectForm.province = this.subjectForm.citys[0]
      this.subjectForm.city = this.subjectForm.citys[1]
      this.subjectForm.area = this.subjectForm.citys[2]
      if (this.subjectForm.dwell.length == 0) {
        this.subjectForm.dwell = val
        this.subjectForm.dwell_province = this.subjectForm.dwell[0]
        this.subjectForm.dwell_city = this.subjectForm.dwell[1]
        this.subjectForm.dwell_area = this.subjectForm.dwell[2]
      }
    },
    dwellCg(val) {
      if (this.subjectForm.dwell.length != 0) {
        this.subjectForm.dwell = val
        this.subjectForm.dwell_province = this.subjectForm.dwell[0]
        this.subjectForm.dwell_city = this.subjectForm.dwell[1]
        this.subjectForm.dwell_area = this.subjectForm.dwell[2]
      }
    },
    reset() {
      this.editId = '';
      this.$refs.addForm.resetFields()
      this.modalVisible = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    query(val) {
      if (val) {
        if (typeof val === 'object') {
          this.page.current = val.current
          this.page.pageSize = val.pageSize
        } else {
          this.page.current = 1
        }
      }
      let obj = Object.assign({
        page: this.page.current,
        limit: this.page.pageSize
      }, this.form);
      getSubject(obj).then((res) => {
        this.data = res.list
        this.page.total = res.count
      })
    },
    resetList() {
      this.page.current = 1
      this.page.pageSize = 10
      this.subjectForm.title = ''
      this.query()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getAccInit() {
      accuseList(this.all).then((e) => {
        this.accuser = e.list
      })
    },
    async handleSearch(name) {
      this.all.title = name
      await this.getAccInit()
    },
    addAlert(id) {
      this.getAccInit()
      if (id) {
        this.editId = id
        accuserInfo({
          id: id
        }).then((res) => {
          this.modalVisible = true
          this.$nextTick(() => {
            this.subjectForm = res.accuser
            this.subjectForm.team_ids = res.accuser.accuserNew.team.map(ele => {
              return ele.team.id
            });

          })
        })
      } else {
        this.editId = '';
        this.modalVisible = true
        this.$nextTick(() => {
          this.$refs.addForm.resetFields()
        })
      }
    },
    debtorsAlert(item) {
      this.listVisible = true
      // this.debtorslist = item.debtors
      this.getdebtorsList(item.accuser_id_new)
    },
    takeAlert(item) {
      this.modalVisible = true
      this.subjectForm = item
      this.subjectForm.citys = [item.province, item.city, item.area]
      this.subjectForm.dwell = [item.dwell_province, item.dwell_city, item.dwell_area]
      this.getAccInit()
      this.editId = item.id
    },
    subjectConfirm() {
      this.subjectForm.party_role = 1
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.editId) {
            plaintiffEdit(Object.assign(this.subjectForm, { id: this.editId })).then((res) => {
              this.$message.success({ content: '修改成功' });
              this.reset()
              this.query();
              this.getdebtorsList(this.forms.accuserIdNew)
            })
          } else {
            plaintiffAdd(this.subjectForm).then((res) => {
              this.$message.success({ content: '添加成功' });
              this.reset()
              this.query();
            })
          }
          
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import url("@/assets/css/topForm");

// .ant-btn {
//   border-color: #1d8bfe;
//   color: #1d8bfe;
// }
// .ant-btn-primary {
//   color: #ffffff;
//   border-color: #1d8bfe;
//   background-color: #1d8bfe;
// }
.tcon {
  padding: 0 20px;
  min-height: 760px;

  .tableList {
    .line {
      display: inline-block;
      width: 1px;
      height: 14px;
      background-color: #dbdcde;
      margin: 0 10px;
      vertical-align: middle;
    }
  }
}

/deep/ .ant-modal-header {
  padding: 20px 40px;
}

/deep/ .ant-modal-body {
  padding: 24px 40px 0;
}

/deep/ .ant-modal-footer {
  border-top: none;
  padding-bottom: 30px;
}

.modal-footer {
  text-align: center;

  button {
    width: 90px;
  }

  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
</style>
